import React from "react";
import PropTypes from "prop-types";
import Logo from "../instances/Logo";
import SectionNumber from "../global/SectionNumber";
import SmartColour from "../../utils/ColourHandler";
import SmartText from "../../utils/TextHandler";
import SmartStyles from "../../utils/StyleHandler";

/********************************
<Logos />
/********************************
Version: 1.2
Created: 11 08 2023
Updated: 19 02 2025
Author: Richy Pears
/********************************
Lists out a collection of logos
/********************************/

const Logos = ({ blok }) => {
  if (!blok) return null; // Escape hatch

  const { copy, items, number, padding, rounded, subtitle, theme, title } =
    blok;

  const colour = SmartColour(theme);

  const columns = { xs: 2, sm: 4, md: 5, lg: 5, xl: 5 };

  return (
    <section
      className={`flex flex-col ${
        colour.classes && colour.classes
      } ${SmartStyles("padding", padding)} ${SmartStyles("rounded", rounded)}`}
    >
      <div className="brand-container flex flex-col gap-10 md:gap-12">
        <SectionNumber title={subtitle && subtitle} number={number && number} />
        {copy?.content[0]?.content && (
          <SmartText className="m-0 text-center brand-remove-last-margin">
            {copy}
          </SmartText>
        )}
        <div className="flex flex-row flex-wrap justify-center w-full md:w-5/6 mx-auto">
          {items &&
            items.map((node, index) => {
              return <Logo columns={columns} node={node && node} />;
            })}
        </div>
      </div>
    </section>
  );
};

export default Logos;

Logos.defaultProps = {
  blok: null,
};

Logos.propTypes = {
  blok: PropTypes.object,
};
